import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ModuleFE_PathwayState } from '../../../../../_entity.js';
import { AwaitModules, ComponentSync, EditableDBItemV3, TS_PropRenderer } from '@nu-art/thunderstorm-frontend';
import { EditableStateTypeTypes, PathwayStateType_Initial, PathwayStateTypeLabelMap } from '@app/pathway-shared';
import { DefaultEditor_InputText } from '@app/styles/frontend/ui-manager/ui-components';
import { asArray } from '@nu-art/ts-common';
import './Editor_PathwayState.scss';
import { FadeScrollWrapper, Header_WithOptionMenu } from '@app/styles';
import { Renderer_PathwayVariables } from '../shared/Renderer_PathwayVariables/Renderer_PathwayVariables.js';
import { Dropdown_PathwayStateType } from '../../../../../_enum/pathway-state-type/ui-components.js';
import { Editor_Preconditions, Editor_Preconditions_Modules } from './inner-renderers/Editor_Preconditions.js';
import { Editor_StateSmartDoc, Editor_StateSmartDoc_Modules } from './inner-renderers/Editor_StateSmartDoc.js';
import { Renderer_PathwayTransitions } from '../shared/Renderer_PathwayTransitions/Renderer_PathwayTransitions.js';
export class Editor_PathwayState extends ComponentSync {
    // ######################## Life Cycle ########################
    __onPathwayStateUpdated = (...params) => {
        if (!this.mounted)
            return;
        const currentStateId = this.props.renderArgs.stateId;
        const states = asArray(params[1]);
        if (states.find(state => state._id === currentStateId))
            this.forceUpdate();
    };
    deriveStateFromProps(nextProps, state) {
        state.editMode = nextProps.renderArgs.editMode;
        state.tabId = nextProps.tabId;
        if (nextProps.renderArgs.stateId && nextProps.renderArgs.stateId !== state.editable?.item._id) {
            state.editable = this.generateEditableItem(nextProps.renderArgs.stateId);
        }
        return state;
    }
    // ######################## Logic ########################
    generateEditableItem(stateId) {
        const pathwayState = ModuleFE_PathwayState.cache.unique(stateId);
        return new EditableDBItemV3(pathwayState, ModuleFE_PathwayState)
            .setOnChanged(async () => this.forceUpdate())
            .setAutoSave(true);
    }
    filterAddableTypes = (type) => {
        const pathwayId = this.props.renderArgs.itemId;
        const allPathwayStates = (ModuleFE_PathwayState.cache
            .filter((state) => state.pathwayIds.includes(pathwayId)))
            .map(state => state.type);
        // Editable state types and initial type can be added any time. other types can be added only once.
        return EditableStateTypeTypes.includes(type) || type === PathwayStateType_Initial || !allPathwayStates.includes(type);
    };
    // ######################## Render ########################
    render() {
        return _jsxs(_Fragment, { children: [this.render_StateHeader(), _jsxs(FadeScrollWrapper, { className: 'e__pathway-state', children: [this.render_Preconditions(), _jsx(Renderer_PathwayTransitions, { workHubItem: this.props.workHubItem, tabId: this.state.tabId, pathwayId: this.props.renderArgs.itemId, stateId: this.state.editable.item._id, editMode: this.state.editMode }), _jsx(Renderer_PathwayVariables, { pathwayId: this.props.renderArgs.itemId, stateId: this.state.editable.item._id }), this.render_SmartDoc()] })] });
    }
    // Ticket #10157 point 1 — compact state header replaces previous State Name / State Type form fields.
    // View mode renders title/subtitle text; edit mode swaps them for inline input + dropdown.
    // State Label hidden per point 2 — field kept in DB, only UI removed.
    render_StateHeader = () => {
        const editable = this.state.editable;
        const editMode = this.state.editMode;
        const stateType = editable.item.type;
        const viewSubtitle = stateType ? `${PathwayStateTypeLabelMap[stateType]} State` : 'State';
        return _jsx(Header_WithOptionMenu, { className: 'e__pathway-state-header', title: editMode
                ? _jsx(DefaultEditor_InputText, { editable: editable, prop: 'name' })
                : editable.item.name, subtitle: editMode
                ? _jsx(Dropdown_PathwayStateType.editable, { editable: editable, prop: 'type', queryFilter: this.filterAddableTypes })
                : viewSubtitle });
    };
    // Ignore Documentation hidden per ticket #10157 point 3 — legacy field, only UI removed
    // private render_IgnoreDocumentation = () => {
    // 	const editable = this.state.editable;
    // 	return <TS_CheckboxV2
    // 		label={'Ignore Documentation'}
    // 		disabled={!this.state.editMode}
    // 		checked={editable.item.ignoreDocumentation}
    // 		onCheck={check => {
    // 			editable.updateObj({ignoreDocumentation: check});
    // 		}}
    // 	/>;
    // };
    render_Preconditions = () => {
        return _jsx(AwaitModules, { modules: Editor_Preconditions_Modules, children: _jsx(TS_PropRenderer.Vertical, { className: 'e__pathway-state__preconditions', label: 'Preconditions (Action / Expression)', children: _jsx(Editor_Preconditions, { editable: this.state.editable, editMode: this.state.editMode }) }) });
    };
    render_SmartDoc = () => {
        return _jsx(AwaitModules, { modules: Editor_StateSmartDoc_Modules, children: _jsx(TS_PropRenderer.Vertical, { label: 'Smart Doc', children: _jsx(Editor_StateSmartDoc, { editable: this.state.editable, editMode: this.state.editMode }) }) });
    };
}
//# sourceMappingURL=Editor_PathwayState.js.map